import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import { CxenseParseTag, SeoTag } from "../../../../components/seo/SeoTag";
import {
  getProvincialCityCandidates,
  getProvinceData,
  getCityData,
  getTaguigLoneDistrict,
  getRegions,
  getPartyList,
  getAllPartyList,
  getPresidentList,
  getVicePresidentList,
  getSenatorList,
} from "../../../api/ph-api";
import RacesPage from "../../../../components/races/RacesPage";
import Fallback from "../../../FallbackPage";

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true,
  };
};

export const getStaticProps = async (context) => {
  let regionList = await getRegions();
  let partyList = await getPartyList();
  let allPartyList = await getAllPartyList();
  let presidential = await getPresidentList();
  let vPresidential = await getVicePresidentList();
  let senatorialList = await getSenatorList();
  let { local_place } = context.params;
  let info = "",
    provincialInfo = null,
    provincialCities = null,
    provincialDistrictContests = null,
    districtContests = "",
    taguigLoneDistrict = null,
    selfLinks = "",
    contests = "";

  switch (true) {
    case local_place.join("/").includes("/"):
      info = await getCityData(local_place.join("/"));
      provincialInfo = await getProvinceData(local_place[0]);
      provincialCities = (await getProvinceData(info?.province?.slug)).cities;
      break;
    case local_place.join("/").includes("-"):
      if (local_place.join("/").includes("-")) {
        if (
          (await getProvinceData(local_place.join("/"))).detail !== "Not found."
        ) {
          info = await getProvinceData(local_place.join("/"));
          provincialCities = info?.cities;
        } else {
          info = await getCityData(local_place.join("/"));
          provincialCities = (await getProvinceData(info?.province?.slug))
            .cities;
          if (
            local_place.join("/").includes("ncr-taguig") ||
            local_place.join("/").includes("ncr-pateros")
          ) {
            taguigLoneDistrict = await getTaguigLoneDistrict(
              local_place.join("/")
            );
          }
        }
      }
      break;
    default:
      info = await getProvinceData(local_place.join("/"));
      provincialCities = info?.cities;
      break;
  }

  if (
    info?.detail !== "Not found." ||
    provincialInfo?.detail !== "Not found."
  ) {
    districtContests = info?.districts
      ?.sort((a, b) => (a.order > b.order ? 1 : -1))
      .map((res) => res.contest_set)
      .flat();

    provincialDistrictContests = provincialInfo?.districts
      ?.sort((a, b) => (a.order > b.order ? 1 : -1))
      .map((res) => res.contest_set)
      .flat();

    selfLinks = {
      provinceInfoGovAndVice:
        provincialInfo !== null
          ? provincialInfo?.contest_set.map(
              (res) => `${res.self_link}candidacies`
            )
          : "",
      contestData: info?.contest_set.map(
        (res) => `${res.self_link}candidacies`
      ),
      districts: districtContests.map((res) => `${res.self_link}candidacies`),
    };

    contests = await getProvincialCityCandidates([
      ...selfLinks.provinceInfoGovAndVice,
      ...selfLinks.contestData,
      ...selfLinks.districts,
    ]);
  }

  if (
    !info ||
    !local_place ||
    !contests ||
    !partyList ||
    !allPartyList ||
    !presidential ||
    !vPresidential ||
    !senatorialList
  ) {
    return {
      props: {
        info,
        provincialCities,
        local_place,
        taguigLoneDistrict,
        contests,
        partyList,
        allPartyList,
        presidential,
        vPresidential,
        senatorialList,
      },
      revalidate: 5,
    };
  }

  return {
    props: {
      info,
      provincialCities,
      local_place,
      taguigLoneDistrict,
      contests,
      regionList,
      partyList,
      allPartyList,
      presidential,
      vPresidential,
      senatorialList,
    },
  };
};

const ProvincePage = ({
  info,
  provincialCities,
  taguigLoneDistrict,
  local_place,
  contests,
  regionList,
  partyList,
  allPartyList,
  presidential,
  vPresidential,
  senatorialList,
}) => {
  let displayName = info?.display_name;
  let isProvince = !!info?.cities;
  let metaName = isProvince
    ? displayName
    : `${displayName}, ${info?.province?.display_name}`;

  const { isFallback } = useRouter();
  const [url, setUrl] = useState("");
  const title = `2022 ELECTION RESULTS: ${metaName}`;
  const description = `Refresh this page to see partial, unofficial, real-time results in ${metaName} based from the Comelec media server election results after polls close on May 9, 2022.The percentage of votes received is computed based on the total number of actual voters in each contest.`;
  const keywords = `2022 Philippine elections, #PHVote, Philippine elections, local elections Philippines, election results Philippines`;
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  if (isFallback) return <Fallback />;
  return (
    info &&
    !local_place.join("/").includes("lone-legislative-district") && (
      <>
        <SeoTag
          title={title}
          description={description}
          keywords={keywords}
          og_image={og_image}
          twitter_og_image={og_image}
          twitter_title={title}
          twitter_description={description}
        />
        <CxenseParseTag title={title} />
        <RacesPage
          national={false}
          info={info}
          taguigLoneDistrict={taguigLoneDistrict}
          provincialCities={provincialCities}
          contests={contests}
          regionList={regionList}
          partyList={partyList}
          allPartyList={allPartyList}
          presidential={presidential}
          vPresidential={vPresidential}
          senatorialList={senatorialList}
          path={`/elections/2022/${local_place}`}
          url={url}
          view="local-results"
        />
      </>
    )
  );
};

export default ProvincePage;
